module.exports = __webpack_public_path__ + "img/Navigation.87426f56.svg";